import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface SubscriptionUpsellModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  description?: string;
}

export function SubscriptionUpsellModal({
  open,
  onOpenChange,
  title = 'Contenido exclusivo para suscriptores',
  description = 'Este contenido es parte de los planes Pro. Suscríbete o pide a tu administrador que te asigne una licencia empresarial para acceder.',
}: SubscriptionUpsellModalProps) {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <div className="mx-auto w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-2">
            <Sparkles className="w-6 h-6 text-primary" />
          </div>
          <DialogTitle className="text-center">{title}</DialogTitle>
          <DialogDescription className="text-center">{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-center gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button
            onClick={() => {
              onOpenChange(false);
              navigate('/planes');
            }}
          >
            <Sparkles className="w-4 h-4 mr-2" />
            Ver planes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
